import { QueryState, QueryStateSentrynel } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query-sentrynel.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IUserRole } from '../core/models/utenti.model';


export const USERROLES_ENDPOINT = 'user-roles';

export const ASSIGN_USERROLE_ENDPOINT = `${USERROLES_ENDPOINT}/assign`;
export const REVOKE_USERROLE_ENDPOINT = `${USERROLES_ENDPOINT}/revoke`;
export const ASSIGNABLEROLES_USERROLE_ENDPOINT = `${USERROLES_ENDPOINT}/assignable`;

export const USERROLES_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(USERROLES_ENDPOINT);

export const userRolesStateConfig: SignalStoreConfig<QueryStateSentrynel<IUserRole>> = {
  initState: {
    list: [],
    sort: {
      field: 'id',
      direction: 'asc'
    }
  }
}
